import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { createLesson, Lesson, LessonDto } from '@app/store/shared/models';
import { LessonValue, LessonValueDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getLesson(id: string): Observable<Lesson> {
        return this.httpClient.get<LessonDto>(`lessons/${id}`).pipe(map((dto) => createLesson(dto)));
    }

    createLesson(value: LessonValue): Observable<Lesson> {
        const dto = new LessonValueDto(value);

        return this.httpClient.post<LessonDto>('lessons', dto).pipe(map((response) => createLesson(response)));
    }

    updateLesson(id: string, value: LessonValue): Observable<Lesson> {
        const dto = new LessonValueDto(value);

        return this.httpClient.patch<LessonDto>(`lessons/${id}`, dto).pipe(map((response) => createLesson(response)));
    }

    deleteLesson(id: string): Observable<void> {
        return this.httpClient.delete<void>(`lessons/${id}`);
    }
}
